import styled from 'styled-components'

export const MessagesDiv = styled.div<{ widgetColor?: string }>`
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;

}
/* Handle */
::-webkit-scrollbar-thumb {
  border-radius:20px;
  background-clip: padding-box;
  background: ${(props) => props.widgetColor}; /* color of the scroll thumb */,
  border-radius: "20px"; /* roundness of the scroll thumb */,
  border: "none"; /* creates padding around scroll thumb */,
}
`

export const ChatsDiv = styled.div<{ widgetColor?: string }>`
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;

}
/* Handle */
::-webkit-scrollbar-thumb {
  border-radius:20px;
  background-clip: padding-box;
  background: ${(props) => props.widgetColor}; /* color of the scroll thumb */,
  border-radius: "20px"; /* roundness of the scroll thumb */,
  border: "none"; /* creates padding around scroll thumb */,
}
`
